import { Observable } from 'rxjs';
import { pairwise, startWith } from 'rxjs/operators';

import store, { storeObserver } from '../../store';

export const useSelector = <TState>(
    mapper: (state: any) => TState,
): Observable<[TState, TState]> => {
    return storeObserver<any, TState>(store, mapper) // TODO revise store import
        .pipe(startWith<any, TState>(mapper(store)), pairwise());
};
